


import {Component, Prop, Vue} from 'vue-property-decorator';
import Feature from '@/interfaces/geo/feature.interface';
import MammadabaMap from '@/interfaces/geo/mammadaba-map.interface';
import {delay, map, mergeMap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import MapFeaturesService from '@/services/map-features.service';
import AppMiniMap from '@/components/mini-map/mini-map.vue';

declare const GeoMammadabaMap: MammadabaMap;

@Component({})
export default class AppMiniMapForRoute extends Vue {

  @Prop()
  public routeId!: string;

  @Prop()
  public url!: string | null;

  public mapRendered: boolean = false;
  private miniMapRef: AppMiniMap | null = null;
  private mapFeaturesService: MapFeaturesService = MapFeaturesService.getInstance();

  public mounted(): void {
    this.miniMapRef = this.$refs.miniMap as AppMiniMap;
    of(null).pipe(
        mergeMap(() => this.mapFeaturesService.loadAllFeatures()),
        mergeMap(() => this.mapFeaturesService.loadAllRouteLayers()),
        mergeMap(() => this.renderMap()),
    ).subscribe();
  }

  private renderMap(): Observable<void> {
    return of(null).pipe(
        mergeMap(() => {
          GeoMammadabaMap.renderMiniMap(
              {
                allFeatures: this.mapFeaturesService.allFeatures(),
                routeLayers: this.mapFeaturesService.allRouteLayers(),
                routeId: this.routeId,
                onClickOnMiniFeature: (object: { layerId: string, objectId: number }) => {},
                onSelectRoute: (feature: Feature) => {},
              },
              this.miniMapRef ? this.miniMapRef.mapContainerElement() : new HTMLDivElement()
          );
          return of(null).pipe(
              delay(50),
              map(() => {
                this.mapRendered = true;
              }),
          );
        })
    );
  }
}
